<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.writeReview')" />
      <v-container class="rounded-lg my-8 pa-5 elevation-3">
        <div class="px-md-5">
          <p class="font-weight-bold secondary--text mb-5">{{ $t('label.orderId') }} {{ poNum }}</p>
          <div class="d-flex flex-row mb-4">
            <img :src="item.product_image" class="mr-2 mr-md-5 order-image rounded-lg elevation-3" />
            <div>
              <p class="text-subtitle-2 font-weight-bold grey--text">
                {{ item.product_subcategory_name }}
              </p>
              <p class="text-body secondary--text">
                {{ item.product_name }}
              </p>
              <p class="text-body secondary--text">
                {{ item.product_volume_variation_name }}
              </p>
            </div>
          </div>
          <v-rating v-model="rating" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
          <v-textarea v-model="comment" :placeholder="$t('placeholder.typeHere')" counter="250"></v-textarea>
          <div class="d-flex flex-row my-4">
            <div class="mx-auto">
              <label for="upload-file" v-show="files.files.length < 4">
                <div class="d-flex flex-column upload-photo-border rounded px-8 py-3">
                  <UploadPhoto class="align-self-center" />
                  <input type="file" id="upload-file" hidden @input="selectFile" />
                  <span class="primary--text text--darken-1">{{ $t('label.uploadPhoto') }}</span>
                </div>
              </label>
            </div>
          </div>
          <div class="d-flex flex-row my-4">
            <div v-for="(image, index) in imgSrc" :key="index" class="position-relative">
              <img class="rounded-1r ma-3" width="150" height="150" :src="image" />
              <v-icon class="close-circle white d-flex primary--text text--darken-1 rounded-circle x-large" @click="removeImage(index)">mdi-close</v-icon>
            </div>
            <div v-show="files.files.length" class="ml-8 align-self-center primary--text text--darken-1">{{ files.files.length }} of 4</div>
          </div>
        </div>
      </v-container>
    </LayoutContent>
    <bottom-bar v-if="canSubmit">
      <v-container class="py-3 d-flex justify-center">
        <v-btn color="primary--text" class="px-15 d-block rounded-pill text-capitalize" @click="submitReview">{{ $t('button.submit') }}</v-btn>
      </v-container>
    </bottom-bar>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '../layouts/LayoutContent.vue'
import UploadPhoto from '@/assets/icons/upload-photo.svg'
import { COMMON, REVIEW } from '@/api'

export default {
  components: { LayoutContent, SectionTitle, UploadPhoto },
  props: {
    poNum: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      rating: 0,
      comment: '',
      imgSrc: [],
      files: new DataTransfer()
    }
  },
  computed: {
    canSubmit() {
      if (this.rating && this.comment) return true
      return false
    }
  },
  methods: {
    selectFile(event) {
      if (this.files.files.length < 4) {
        let file = new File(event.target.files, event.target.files[0].name)
        this.files.items.add(file)
        this.imgSrc.push(URL.createObjectURL(file))
      }
    },
    removeImage(index) {
      this.imgSrc.splice(index, 1)
      this.files.items.remove(index)
    },
    async submitReview() {
      let uploadRes
      if (this.files.files.length > 0) {
        let formData = new FormData()
        for (const file of this.files.files) {
          formData.append('media[]', file)
        }
        const uploadMediaData = {
          name: 'review',
          formData
        }
        uploadRes = await COMMON.uploadMedia(uploadMediaData)
      }

      let url = []
      if (uploadRes && uploadRes.status == 'Success') {
        url = uploadRes.url
      }
      let body = { type: 1, item_id: this.item.product_id, rating: this.rating, comment: this.comment }
      if (this.item.product_volume_variation_id) Object.assign(body, { product_volume_variation_id: this.item.product_volume_variation_id })

      let reviewParams = {
        comments: {
          comments: [body]
        },
        order_id: this.orderId
      }

      if (url.length > 0) {
        reviewParams = {
          ...reviewParams,
          ...{
            medias: {
              medias: [{ product_id: this.item.product_id, url }]
            }
          }
        }
      }

      const submitReviewRes = await REVIEW.submitReview(reviewParams)
      if (submitReviewRes.review_id.length > 0) {
        this.$router.push({ name: this.$constants.ROUTE_NAME.PRODUCT_REVIEW })
        this.$toast.success(this.$t('message.productReviewSuccess'))
      } else {
        console.log('error')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-image {
  width: 120px;
  height: 120px;
  object-fit: cover;

  @media only screen and (min-width: 640px) {
    width: 180px;
    height: 180px;
  }
  @media only screen and (min-width: 1800px) {
    width: 200px;
    height: 200px;
  }
}

.upload-photo-border {
  border: 1px solid var(--v-primary-darken1);
}
.close-circle {
  position: absolute;
  right: 25px;
  top: 25px;
  height: 40px;
  width: 40px;
  cursor: pointer;
}
</style>
